import React, { useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { Box, HeaderMenu, SearchInputGroup } from '@maui/elements'
import { useAuthProvider } from './useAuthProvider'
import { OrgsList } from './OrgsList'

export const OrgSwitcher = ({ returnTo }) => {
  const { claims: { organizations } = {}, selectedOrg } = useAuthProvider()
  const [filterText, setFilterText] = useState('')
  const isMultiOrg = !!organizations?.length && organizations.length > 1

  const filteredOrgs = useMemo(() => {
    const query = (filterText || '').trim().toLowerCase()

    if (!query) {
      return organizations
    }

    return organizations.filter(({ name }) => name.toLowerCase().includes(query))
  }, [filterText, organizations])

  if (!isMultiOrg) {
    return null
  }

  return (
    <Box display="inline-flex">
      <HeaderMenu
        color="colorTextMain"
        minWidth='218px'
        label={
          <Box
            width='fit-content'
            overflow='hidden'
            textOverflow='ellipsis'
            whiteSpace='nowrap'
          >
            {selectedOrg?.name}
          </Box>
        }
      >
        <SearchInputGroup
          margin="spaceGapMedium"
          onClear={() => setFilterText('')}
          inputProps={{
            onChange: e => setFilterText(e.target.value),
            placeholder: 'Search Organizations',
            value: filterText,
          }}
        />
        <OrgsList orgs={filteredOrgs} returnTo={returnTo} />
      </HeaderMenu>
    </Box>
  )
}

OrgSwitcher.propTypes = {
  returnTo: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
}
